import React from "react"
import Link from './link';

import { CalendarOutlined } from '@ant-design/icons'
import { ga4 } from "../handlers/google-analytic"
import { getGG } from "../state/store"

const UpcomingBox = ({ booking }) => (
  <Link
    to={'/booking/details'}
    state={{ bookingCode: booking.bookingCode }}
    className={'upcoming-booking-box'}
    button_id='upcomingPrivilegeButtonId'
    onClick={() => {
      const { user } = getGG().store.getState()
      ga4.gtag('event', 'upcoming_booking_home', {
        name: booking.bookingName,
        category: 'upcoming',
        trigger: 'upcomingPrivilegeButtonId',
        profile_id: user.profileId
      })
    }}
  >
    <div className={'upcoming-countdown-title'}>{booking.bookingComing}</div>
    <div className={'upcoming-content'}>
      <div className={'upcoming-icon'}><CalendarOutlined /></div>
      <div className={'upcoming-detail-box'}>
        <div className={'upcoming-datetime'}>{booking.bookingDate}</div>
        <div className={'upcoming-title'}>{booking.branchName}</div>
        <div className={'upcoming-detail'}>{booking.bookingName}</div>
      </div>
    </div>
  </Link>
)

export default UpcomingBox
